import React from 'react'
import './Loader.scss'

const Loader = ({ loaderStyles = {}, containerStyles = {}, text = '', noBlur = false }) => {
  return (
    <div style={containerStyles} className={`overlay ${noBlur ? 'no-blur' : ''}`}>
      <div style={loaderStyles} className='loader'></div>
      <div className='loader-text'>{text}</div>
    </div>
  )
}

export default Loader